import { Typo3AccomodationRoomData, Typo3AccomodationRoomState } from '@/types'
import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  facets: any
  dropdownFacets: any
  startDate: Date | null
  endDate: Date | null
  storeFilteredItems: number
  storeItemsToShow: number
  modalOpen: boolean
  search: string
  sortBy:
    | 'random'
    | 'name-asc'
    | 'name-desc'
    | 'price-asc'
    | 'price-desc'
    | 'date-asc'
    | 'date-desc'
    | 'distance-asc'
    | 'distance-desc'
    | 'difficulty-asc'
    | 'difficulty-desc'
    | 'duration-asc'
    | 'duration-desc'
    | null
  isReady: boolean
  isOpenToday: boolean
  rooms: Typo3AccomodationRoomState[]
  roomsData: Typo3AccomodationRoomData[] | null
  items: React.JSX.Element | React.JSX.Element[] | undefined
}
interface Action {
  setFacets: (facets: State['facets']) => void
  setItems: (items: State['items']) => void
  setIsOpenToday: (openToday: State['isOpenToday']) => void
  setIsReady: (isReady: State['isReady']) => void
  setDropdownFacets: (dropdownFacets: State['dropdownFacets']) => void
  setStoreFilteredItems: (
    storeFilteredItems: State['storeFilteredItems']
  ) => void
  setSearch: (search: State['search']) => void
  setStoreItemsToShow: (storeItemsToShow: State['storeItemsToShow']) => void
  setStartDate: (startDate: State['startDate']) => void
  setEndDate: (endDate: State['endDate']) => void
  setModalOpen: (modalOpen: State['modalOpen']) => void
  setSortBy: (sortBy: State['sortBy']) => void
  setRooms: (rooms: State['rooms']) => void
  setRoomsData: (roomsData: State['roomsData']) => void
  reset: () => void
}

const baseStoreAccomodation = create<State & Action>((set) => ({
  facets: [],
  isReady: false,
  dropdownFacets: [],
  startDate: null,
  endDate: null,
  storeFilteredItems: 0,
  storeItemsToShow: 0,
  modalOpen: false,
  search: '',
  sortBy: null,
  rooms: [{ adults: 2, children: 0, childrenAges: [] }],
  roomsData: null,
  items: undefined,
  isOpenToday: false,
  setItems: (items) => set(() => ({ items })),
  setIsReady: (isReady) => set(() => ({ isReady })),
  setSortBy: (sortBy) => set(() => ({ sortBy })),
  setStartDate: (startDate) => set(() => ({ startDate })),
  setEndDate: (endDate) => set(() => ({ endDate })),
  setStoreFilteredItems: (storeFilteredItems) =>
    set(() => ({ storeFilteredItems })),
  setStoreItemsToShow: (storeItemsToShow) => set(() => ({ storeItemsToShow })),
  setFacets: (facets) => set(() => ({ facets })),
  setDropdownFacets: (dropdownFacets) => set(() => ({ dropdownFacets })),
  setModalOpen: (modalOpen) => set(() => ({ modalOpen })),
  setSearch: (search) => set(() => ({ search })),
  setIsOpenToday: (openToday) => set(() => ({ isOpenToday: openToday })),
  setRooms: (rooms) => set(() => ({ rooms })),
  setRoomsData: (roomsData) => set(() => ({ roomsData })),
  reset: () =>
    set({
      facets: [],
      // storeFilteredItems: 0,
      // storeItemsToShow: 0,
      startDate: null,
      endDate: null,
      search: '',
      sortBy: null,
      dropdownFacets: [],
      rooms: [{ adults: 2, children: 0, childrenAges: [] }],
      roomsData: null
    })
}))

const useStoreAccomodation = createSelectors(baseStoreAccomodation)

export default useStoreAccomodation
